import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';
import { mapExperienceResponseToExperience } from './mapping/experience';

export function useGetExperience(id?: string | number) {
  const experienceId = typeof id === 'string' ? id : id?.toString();

  const response = useQuery({
    queryKey: [CORE_QUERY_KEYS.experience, { id: experienceId }],
    queryFn: experienceId
      ? () =>
          apiRequest({
            path: ENDPOINTS.getExperience,
            params: { id: experienceId },
          }) as Promise<ExperienceResponse>
      : () => Promise.resolve(undefined),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!experienceId,
  });

  return {
    ...response,
    data: mapExperienceResponseToExperience(response.data),
  };
}
